import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export const animateCarouselOut = (sectionId: string, elementsIds: string) => {
  const animation = gsap.timeline().fromTo(elementsIds, { opacity: 1 }, { opacity: 0 });

  const scrollTrigger = ScrollTrigger.create({
    animation,
    trigger: sectionId,
    start: '40% bottom',
    end: 'bottom bottom',
    scrub: true,
  });

  return {
    kill: () => {
      scrollTrigger.kill();
      animation.kill();
    },
  };
};
